import {
  Box,
  Button,
  Popover,
  TypographyStylesProvider,
  Text,
  Image,
} from "@mantine/core";
import React from "react";
import { IconDatabase, IconTrash } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite"; // Add the missing imports
import SimpleImage from "../articlesHelpers/SimpleImage";

export const DELETING_YOUR_NODE_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Rizful Node is designed from the ground-up to allow for temporary &
      disposable nodes.
    </p>
    <p>
      This means you can delete your nodes. And this means you can delete your
      account, if all your nodes are deleted.
    </p>
    <p>
      There is however one major caveat:{" "}
      <strong>
        If you have a BTC balance above 3,000 satoshis, any open channels, or
        any channels in process of closing, Rizful Node will NOT allow you to
        delete either your node(s), or your account.
      </strong>
    </p>
    <p>This, our friends, is for your own protection.</p>
    <p>
      So, if you have any balance, or any channels, and you use this button...
    </p>
    <Popover width={250} position="bottom" withArrow shadow="md">
      <Popover.Target>
        <Button mb="md" color="red" leftSection={<IconTrash />}>
          Delete This Node
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Text size="xs">
          This is just the documentation, so this button doesn't do anything.
          Look for this button in the Rizful Node interface and use it there.
        </Text>
      </Popover.Dropdown>
    </Popover>
    <p>...You'll be be blocked by a message like this...</p>

    <SimpleImage
      h={150}
      // w={356}

      src="docs_images/delete-this-node-cant-delete.png"
    />
    <p>
      At this point, you need to{" "}
      <a href="/docs/opening-channels#closing-channels">close your channels</a>,
      wait for the amounts in those channels to fully settle into BTC, and then{" "}
      <a href="/docs/deposit-withdraw-btc#withdraw-btc">withdraw your BTC</a> to
      below 3,000 satoshis.
    </p>
    <p>
      {" "}
      When you've done that, use the "Delete This Node" button again, and....
    </p>

    <SimpleImage
      h={350}
      // w={356}

      src="docs_images/delete-this-node-final-warning2.png"
    />

    <p>
      {" "}
      Think about this carefully. You've already closed your channels and
      withdrawn your BTC. There's just one pitfall remaining.{" "}
    </p>
    <p>
      {" "}
      Think back carefully... did you make any BTC addresses with this node,
      and, if so, is it possible that anyone will attempt to send funds to these
      addresses in the future? If the answer is "YES", then please don't delete
      your node until you are SURE nobody will attempt to make a payment to it!{" "}
    </p>
  </TypographyStylesProvider>
);
